import { useEffect } from 'react';
import { PERMISSIONS } from 'store/baseConfig';
import { ProfileSection, ContractDate, CompanyList } from './sub-sections/index';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/system';
import { setCompanyMenuItems } from 'store/slice/SliceHeaderData';
import { selectIsMobileLogin } from 'store/slice/SliceAuth';

const HeaderSections = () => {
    const { loginState, loginUserInfo } = useSelector((state) => state.auth);
    const { companyMenuItems, selectCompanyNo, contractDate } = useSelector(state => state.header);
    const isMobile = useSelector(selectIsMobileLogin);
    const dispatch = useDispatch();

    const userInfo = loginUserInfo?.user;
    const perm = userInfo ? userInfo.perm_id : '31'; // 권한 id (관리자:01, 운영자:11, 사용자:21)
    const userName = userInfo ? userInfo.login_id : '알수 없음';
    
    // userSubName 설정: 권한과 모바일 여부에 따라 corp_nm 또는 empl_nm 사용
    let userSubName = '';
    if (userInfo) {
        if (perm === PERMISSIONS.SUPER_ADMIN) {
            userSubName = ''; // 관리자인 경우 빈값
        } else if (perm === PERMISSIONS.ADMIN && !isMobile) {
            userSubName = userInfo.corp_nm || ''; // 운영자이면서 모바일이 아닌 경우 corp_nm
        } else {
            userSubName = userInfo.empl_nm || ''; // 사용자이거나 모바일인 경우 empl_nm
        }
    }

    let userRole = '사용자';

    useEffect(() => {

        switch (perm) {
            case PERMISSIONS.SUPER_ADMIN:
                userRole = '관리자';
                break;
            case PERMISSIONS.ADMIN:
                userRole = '운영자';
                break;
            case PERMISSIONS.USER:
                userRole = '사용자';
                break;
            default:
                userRole = '사용자';
        }
    }, [dispatch, loginState]);

    useEffect(() => {
        if (loginState && loginUserInfo?.user?.perm_id === PERMISSIONS.SUPER_ADMIN) {
            dispatch(setCompanyMenuItems());
        }
    }, [dispatch, loginState, loginUserInfo]);

    if (!loginState) {
        return (<></>);
    }

    switch (perm) {
        case PERMISSIONS.SUPER_ADMIN:
            userRole = '관리자';
            break;
        case PERMISSIONS.ADMIN:
            userRole = '운영자';
            break;
        case PERMISSIONS.USER:
            userRole = '사용자';
            break;
        default:
            userRole = '사용자';
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {perm === PERMISSIONS.SUPER_ADMIN ? <CompanyList /> : null}
            {!isMobile && (perm === PERMISSIONS.SUPER_ADMIN || perm === PERMISSIONS.ADMIN) ? <ContractDate /> : null}
            <ProfileSection perm={perm} userName={userName} userRole={userRole} userSubName={userSubName} isMobile={isMobile} />
        </Box>
    );
};

export default HeaderSections;
